import { action, reaction, extendObservable, computed } from "mobx";
import FormStore from "./formStore";
import directions from "../constants/directions";

const { EAST, WEST, NORTH, SOUTH } = directions;
class ModelBasedAlertingStore extends FormStore {
  constructor(setiApi, routerStore) {
    super(routerStore);

    this.setiApi = setiApi;
    this.routerStore = routerStore;
    this.data = {};
    this.collectionDates = [];
    this.defaults = {
      venueId: "22",
      season: "2019",
      direction: `${EAST},${WEST},${NORTH},${SOUTH}`
    };

    extendObservable(this, {
      isLoading: false,
      formValues: {
        venueId: this.defaults["venueId"],
        season: this.defaults["season"],
        direction: this.defaults["direction"]
      },
      fetchData: action(() => {
        this.isLoading = true;
        this.setiApi.fetchModelBasedAlertingData(this.params).then(data => {
          this.data = data;
          this.isLoading = false;
        });
      }),
      params: computed(() => ({
        venueId: this.formValues.venueId,
        season: this.formValues.season,
        directions: this.formValues.direction.split(",")
      }))
    });

    reaction(
      () => this.routerStore.location && this.routerStore.location.search,
      () => {
        if (this.routerStore.isModelBasedAlertingTab) {
          this.updateFromUrlParams(this.routerStore.location.search);
          this.fetchData();
        }
      },
      true
    );
  }
}

export default ModelBasedAlertingStore;



// WEBPACK FOOTER //
// ./src/stores/modelBasedAlertingStore.js